import { makeStyles, styled, Theme, Typography } from '@material-ui/core';
import React, { FC } from 'react';
import { Button } from '../buttons';
import { FontAwesomeSpriteButton } from '../FontAwesomeLocal';
import { SpriteIconsSolid } from 'src/config/api/models/FontAwesome';
import { VideoPlayer } from 'src/modules/trajectory/components/TrajectoryDetail/blocks/VideoPlayer';

export type NewsMessageProps = {
  title: string;
  children: React.ReactNode;
  buttonLabel: string;
  onButtonClick?: Function;
  videoUrl?: string;
  onClose: Function;
  buttonUrl?: string;
};

export const useStylesWelcomeMessage = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: '1.5rem',
    '@media (max-width: 900px)': {
      flexDirection: 'column-reverse !important',
      '& iframe': { width: '100%' },
    },
  },
});

const StyledFlexContainer = styled('div')<Theme, { direction?: 'row' | 'column' }>(
  ({ direction = 'row' }) => ({
    display: 'flex',
    flexDirection: direction,
    justifyContent: 'space-between',
  })
);

const StyledTitleTypography = styled(Typography)<Theme>(({ theme }) => ({
  marginBottom: theme.spacing(4),
  fontWeight: 500,
  fontSize: theme.typography.bodyMd.fontSize,
  color: theme.palette.offblack,
}));

const StyledMessageTypography = styled('div')<Theme>(({ theme }) => ({
  fontWeight: 400,
  fontSize: theme.typography.body2.fontSize,
  marginBottom: theme.spacing(2),
}));

const StyledNewsMessage = styled('div')<Theme>(({ theme }) => ({
  background: theme.palette.grey['50'],
  padding: theme.spacing(4),
  borderTopRightRadius: 10,
  borderTopLeftRadius: 10,
}));

const NewsMessage: FC<NewsMessageProps> = ({
  title = 'Title',
  children,
  buttonLabel,
  onButtonClick = () => null,
  videoUrl,
  buttonUrl,
  onClose = () => null,
}: NewsMessageProps) => {
  const MessageClasses = useStylesWelcomeMessage();
  return (
    <StyledNewsMessage>
      <StyledFlexContainer>
        <StyledTitleTypography>{title}</StyledTitleTypography>
        <FontAwesomeSpriteButton
          buttonStyle={{ width: 23, height: 23, padding: 0 }}
          icon={SpriteIconsSolid.XMARK}
          color={'grey'}
          iconSize="1x"
          onClick={() => onClose()}
        />
      </StyledFlexContainer>
      <div className={MessageClasses.root}>
        <StyledFlexContainer direction="column">
          <StyledMessageTypography>{children}</StyledMessageTypography>
          <div>
            <Button onClick={() => onButtonClick()} href={buttonUrl}>
              {buttonLabel}
            </Button>
          </div>
        </StyledFlexContainer>
        {videoUrl && <VideoPlayer height="245px" url={videoUrl} />}
      </div>
    </StyledNewsMessage>
  );
};

export default NewsMessage;
